import { PublicStripeProvider } from "@/config/publicStripe";
import { useClientBookingContext } from "@/contexts/clientBookingContext";
import CollectCreditCard from "./collectCreditCard";

export default function BookingCollectCreditCard() {
  const { medspaData } = useClientBookingContext();

  return (
    <PublicStripeProvider stripeAccountId={medspaData.stripeAccountId}>
      <CollectCreditCard />
    </PublicStripeProvider>
  );
}
